import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { Container } from 'types/Watchlist';

/** All the available columns */
export enum Column {
  OceanBol = 'oceanBol',
  ContainerNumber = 'containerNumber',
  State = 'state',
  MotherVessel = 'motherVessel',
  VesselArrival = 'vesselArrival',
  PickupLocation = 'pickupLocation',
  LastFreeDay = 'lastFreeDay',
  CustomsHold = 'customsHold',
  FreightHold = 'freightHold',
  ShippingLineHold = 'lineHold',
  // UsdaHold = 'usdaHold',
  TmfHold = 'tmfHold',
  CtfHold = 'ctfHold',
  TerminalHold = 'terminalHold',
  OtherHold = 'otherHold',
  Demurrage = 'demurrage',
  YardLocation = 'yardLocation',
  PickupAppointment = 'pickupAppointment',
  GatedOut = 'gatedOut',
  EmptyReturned = 'emptyReturned',
  ReturnLocation = 'returnLocation',
  ReferenceId = 'referenceId',
  EstPerDiemLFD = 'estPerDiemLFD',
  EstPerDiemCharges = 'estPerDiemCharges',
  DisputeOpportunity = 'disputeOpportunity',
  EstSavings = 'estSavings',
  LastKnownStatus = 'lastKnownStatus',
  DeletedOn = 'deletedOn',
  DeletedBy = 'deletedBy',
}

export type CellProps = GridRenderCellParams<Container>;

export type OnCellClick = (container: Container, column: Column) => void;
export interface ClickableCellProps extends CellProps {
  onCellClick?: OnCellClick;
}
